import PlainGallery from "./js/plainGallery";
import LoaderThree from "./js/loaderThree.js";
import './styles.css';

let gallery = null;

if(document.querySelector('.archive_three_container')){
    console.log('110225');
    if(!gallery){
        gallery = new PlainGallery();
    }
}

if(document.querySelector('.globals')){
    const loader = new LoaderThree('.globals');

    setTimeout(() => {
        document.querySelector('.globals').classList.add('loaded');
        loader.start();
    }, 200);

    document.querySelectorAll('a:not([href="#"])').forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            let href = el.getAttribute('href');
            loader.reverse(() => {
                window.location.href = href;
            });
        });
    });
}